<template>
  <LayoutDefault>
    <template v-slot:title>
      <h1 class="px-4 flex" v-if="challenge">
        <span v-if="isLastChallenge"> Desafio Atual</span>
        <span v-else class="block text-primary text-4xl -mt-3"
          >#{{ challenge.number }}</span
        >
      </h1>
    </template>

    <Challenges />
  </LayoutDefault>
</template>
<script>
import Challenges from "../components/Challenges";
import LayoutDefault from "../layouts/LayoutDefault";
export default {
  name: "ChallengeView",
  components: {
    LayoutDefault,
    Challenges
  },
  data() {
    return { isLastChallenge: true };
  },

  computed: {
    challenge: function() {
      if (this.isLastChallenge) {
        return this.$store.state.lastChallenge;
      } else {
        return this.$store.state.selectedChallenge;
      }
    }
  },
  mounted() {
    if (this.$route.params.challengeId) {
      this.isLastChallenge = false;
    } else {
      this.isLastChallenge = true;
    }
  }
};
</script>
